import React from "react";
import articles from "../../data/articles.json";
import events from "../../data/events.json";
import "./articleList.css";
import ArticleRow from "./ArticlesRow";

const ArticleList = ({ title = "TITLE", event = false }) => (
  <section className={event ? "article-list-section event" : "article-list-section"}>
    <h2 className="article-list-title">{title}</h2>

    {event || articles.map(({ id, ...rest }) => (
      <ArticleRow key={id} {...rest} />
    ))}

    {event && events.map(({ id, ...rest }) => (
      <ArticleRow key={id} {...rest} />
    ))}
  </section>
);

export default ArticleList;
